import React from 'react';
import PropTypes from 'prop-types';

const ListItemContentDetail = props => (
  <p key={`detail-${props.detail}`}>{props.detail}</p>
);

ListItemContentDetail.propTypes = {
  detail: PropTypes.string.isRequired,
};

export default ListItemContentDetail;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/components/ListItemContentDetail.jsx